import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const TokenPluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default TokenPluginPage